export default {
  props: {
    optionList: {
      type: Array,
      default: () => [{
        value: "1",
        text: "在线",
        iconstyle: {
          "background-color": "#11FF00"
        },
        textStyle: {}
      }, {
        value: "2",
        text: "离线",
        iconstyle: {
          "background-color": "#FF0000"
        },
        textStyle: {}
      }]
    },
    value: {
      type: String,
      default: '1'
    },
    reverse: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isHeighter() {
      //cache the result for performance. 
      return this.optionList.find(x => x.value == this.value);
    }
  }
};